/**
 * @author       Matthieu Devlin (matt@zumper.com)
 * @copyright    Copyright (c) 2020, Zumper
 * @description  getKeySeparator.ts
 */

import { EnhancedStorageOptions } from '../types/EnhancedStorageOptions'

export const getKeySeparator = (options: EnhancedStorageOptions) => {
  return options.keySeparator ?? ':'
}
